/* eslint no-restricted-globals: ["error", "event", "fdescribe"] */
/* eslint no-console: 0 */

import '../src/stylesheets/account_dashboard.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import AccountDashboard from '../src/javascript/components/account_dashboard/AccountDashboard.tsx';

window.addEventListener('load', () => {
  console.log(`ShieldGPS Dashboard - Version ${process.env.VERSION}`);
  console.log(`Platform: ${process.env.PLATFORM}`);
  console.log(`Environment: ${process.env.NODE_ENV}`);

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/dashboardServiceWorker.js')
      .then((registration) => {
        console.log('Service worker registration successful');
        console.log(registration);
      });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AccountDashboard />);
